"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIToggleGroup = _interopRequireDefault(require("UIComponents/input/UIToggleGroup"));

var _Rating = _interopRequireDefault(require("ecosystem-marketplace-core/components/reviews/Rating"));

var _RatingTypes = require("ecosystem-marketplace-core/constants/reviews/RatingTypes");

var _RadioInput = _interopRequireDefault(require("../inputs/RadioInput"));

var ratingValues = [4, 3, 2, 1];

var OverallRatingToggleGroup = function OverallRatingToggleGroup(_ref) {
  var _onChange = _ref.onChange,
      checkedValue = _ref.value;
  var checkedValueNumber = parseInt(checkedValue, 10) || 0;
  return _react.default.createElement(_UIToggleGroup.default, {
    name: "rating"
  }, ratingValues.map(function (rating) {
    return _react.default.createElement(_RadioInput.default, {
      key: rating,
      checked: rating === checkedValueNumber,
      onChange: function onChange(_ref2) {
        var value = _ref2.target.value;
        return _onChange(value);
      },
      value: rating,
      alignment: "center"
    }, _react.default.createElement("div", {
      // We overlay a div onto the Rating component to intercept click events and trigger the
      // on change handler, since the disabled static rating kills click event propagation.
      style: {
        width: '100%',
        height: '100%',
        position: 'absolute',
        cursor: 'pointer',
        zIndex: 5
      },
      onClick: function onClick() {
        return _onChange("" + rating);
      }
    }), _react.default.createElement(_Rating.default, {
      rating: rating,
      type: _RatingTypes.STAR_RATING_FILLED,
      label: _react.default.createElement(_FormattedMessage.default, {
        message: "appMarketplace.storefront.filters.rating.andUp"
      }),
      labelSize: "sm"
    }));
  }));
};

OverallRatingToggleGroup.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  value: _propTypes.default.string
};
var _default = OverallRatingToggleGroup;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/sidebar/filters/OverallRatingToggleGroup.js
// module id = 713
// module chunks = 209 210 211 212